import { render } from "./AllProjectsPage.vue?vue&type=template&id=29f2c4a7&scoped=true"
import script from "./AllProjectsPage.vue?vue&type=script&lang=js"
export * from "./AllProjectsPage.vue?vue&type=script&lang=js"

import "./AllProjectsPage.vue?vue&type=style&index=0&id=29f2c4a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f2c4a7"]])

export default __exports__